import React, { useEffect, useState } from 'react'
import './Format.css'
import Picker from '@emoji-mart/react';
import data from '@emoji-mart/data';
// import { firebase } from '../firebase';
// import db from '../firebase'
// import { getDeviceToken } from '../utils'
// import useAuth from '../Hooks/useAuth';
// import { FaGear } from "react-icons/fa6";
import { MdContentCopy } from "react-icons/md";
import { GrPowerReset } from "react-icons/gr";
// import BoldTextEditor from './bold';
import ReactGA from 'react-ga4'

function Format() {
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search, title: "Format Page" });

  }, [])
  // Add formatting to text if emoji is first character
  // Emoji is removed if formatted using another option
  // const userAuth = useAuth()
  // console.log(userAuth)
  const [prevText, setPrevText] = useState('')
  // const [prevFormat, setPrevFormat] = useState('')
  const [originalText, setOriginalText] = useState('')
  const [formatText, setFormatText] = useState('')
  const [showEmojiPicker, setShowEmojiPicker] = useState(false)
  //eslint-disable-next-line
  const [selectedEmoji, setSelectedEmoji] = useState(null)

  // const [usesLeft, setUsesLeft] = useState(null)

  // const fetchUsesLeft = async () => {
  //   const token = await getDeviceToken()

  //   await db.collection('deviceTokens')
  //     .doc(token)
  //     .get()
  //     .then((doc) => {
  //       if (doc.exists) {
  //         setUsesLeft(10 - doc.data().Uses)

  //         // condition if 0 uses left
  //         if (doc.data().Uses === 10) {
  //           alert('Sign up with email')
  //         }
  //       }
  //     })
  // }

  // const incrementUses = async () => {
  //   const token = await getDeviceToken()

  //   await db.collection('deviceTokens').doc(token).update({
  //     Uses: firebase.firestore.FieldValue.increment(1)
  //   }).then(() => {
  //     // console.log('Field incremented successfully!');
  //   }).catch((error) => {
  //     console.error('Error incrementing field:', error);
  //   });

  // }

  // useEffect(() => {
  //   if (userAuth.auth === null) {
  //     fetchUsesLeft()
  //   }

  //   // console.log(userAuth)
  //   //eslint-disable-next-line
  // }, [userAuth]);

  useEffect(() => {
    // compare with original text when format text != ""
    // if (usesLeft === 0 && userAuth.auth.length === 0) {
    //   alert('please sign up using email, You have used all 10 uses.')
    // } else {
    if ((prevText === "") && formatText !== "") {
      setPrevText(originalText)

      ReactGA.event({
        action: "Text Formatted",
        category: "User interaction",
        label: "Text Formatted"
      })

      // if (userAuth.auth === null) {
      //   incrementUses()
      //   setUsesLeft(prev => --prev)
      //   // console.log(usesLeft)
      // }

    } else if (prevText !== originalText && prevText !== "") {
      setPrevText(originalText)

      ReactGA.event({
        action: "Text Formatted",
        category: "User interaction",
        label: "Text Formatted"
      })

      // if (userAuth.auth === null) {
      //   incrementUses()
      //   setUsesLeft(prev => --prev)
      //   // console.log(usesLeft)
      // }

    }
    // }
    // eslint-disable-next-line 
  }, [formatText])

  const upperCaseAll = () => {
    setFormatText(prevText.length === 0 ? originalText.slice(0,).toUpperCase() : prevText !== formatText ? originalText.toUpperCase() : formatText.slice(0,).toUpperCase())

    // if emoji/numbers are added then keep it
  }

  const lowerCaseAll = () => {
    // setFormatText(originalText.slice(0,).toLowerCase())
    setFormatText(prevText.length === 0 ? originalText.slice(0,).toLowerCase() : prevText !== formatText ? originalText.toLowerCase() : formatText.slice(0,).toLowerCase())
  }

  const capitalizeWords = () => {
    let splitText = originalText.split(' ')
    splitText = splitText.map(item => item = item.charAt(0).toUpperCase() + item.slice(1))
    setFormatText(splitText.join(' '))
  }

  const capitalizeSentences = () => {
    let splitSentence = originalText.split('.')
    splitSentence = splitSentence.map(item => item = item.trim().charAt(0).toUpperCase() + item.trim().slice(1))
    setFormatText(splitSentence.join('. '))
  }

  const capitalizeList = () => {
    const emojiRegex = /\p{Emoji}/u;

    if (originalText.trim().length === 0) {
      console.log('Original text is empty');
    } else {
      let splitText = formatText.split('\n');
      // console.log(splitText, 'formatted text');

      if (splitText[0].match(emojiRegex)) {
        let splitOriginalText = originalText.split('\n');
        // console.log(splitOriginalText, 'original text');

        splitText = splitText.map((item, index) => {
          if (index < splitOriginalText.length) {
            let indexOfFirstLetter = item.toLowerCase().indexOf(splitOriginalText[index].toLowerCase());
            if (indexOfFirstLetter !== -1) {
              item = `${item.slice(0, indexOfFirstLetter)}${item.charAt(indexOfFirstLetter).toUpperCase()}${item.slice(indexOfFirstLetter + 1)}`;
            }
          }
          return item;
        });
      } else {
        splitText = splitText.map(item => item = `${item.charAt(0).toUpperCase()}${item.slice(1)}`);
      }
      setFormatText(splitText.join('\n'));
    }
  };

  const sortAlphabeticalAscending = () => {

    if (prevText === "") {
      let splitText = originalText.split('\n')
      splitText = splitText.sort((a, b) => a.length - b.length)
      setFormatText(splitText.join('\n'))
    } else {
      let splitText = formatText.split('\n')
      splitText = splitText.sort((a, b) => a.length - b.length)
      setFormatText(splitText.join('\n'))
    }
  }

  const sortAlphabeticalDescending = () => {
    if (prevText === "") {
      let splitText = originalText.split('\n')
      splitText = splitText.sort((a, b) => b.length - a.length)
      setFormatText(splitText.join('\n'))
    } else {
      let splitText = formatText.split('\n')
      splitText = splitText.sort((a, b) => b.length - a.length)
      setFormatText(splitText.join('\n'))
    }
  }


  const addEmoji = (originalText, emoji) => {
    let splitText = originalText.split('\n');

    // if first character is emoji remove
    const emojiRegex = /\p{Emoji}/u

    if (splitText[0].match(emojiRegex)) {
      // let splitOriginalText = originalText.split(' ')[0]
      // let indexOfFirstLetter = splitText[0].indexOf(splitOriginalText)
      // console.log(splitText[0])

      // console.log(indexOfFirstLetter)

      // splitText = splitText.map(item => item = `${emoji} ${item.slice(indexOfFirstLetter,)}`)
      splitText = splitText.map(item => {
        let itemCopy = item.slice(0,).split(' ')
        // console.log(itemCopy)
        item = `${emoji} ${itemCopy.splice(1, 0).join(' ')}${itemCopy.slice(1,).join(' ')}`
        return item
      })

    } else {

      splitText = splitText.map(item => item = `${emoji} ${item}`)
    }
    // const emojiRegex = /\u{1F449}/u;
    // console.log(splitText[0])
    // console.log(splitText[0].codePointAt(0))
    // console.log(emojiRegex.test(splitText[0][0]))
    return splitText.join('\n');
  };

  const addCheckMarkEmoji = () => {
    // const formattedText = addEmoji(originalText.trim().length === 0 ? formatText : originalText, '✅');

    const formattedText = addEmoji(prevText.length === 0 ? originalText : prevText !== originalText ? originalText : formatText, '✅');
    setFormatText(formattedText);
  };

  const addRightEmoji = () => {
    // const formattedText = addEmoji(originalText.trim().length === 0 ? formatText : originalText, '👉');
    const formattedText = addEmoji(prevText.length === 0 ? originalText : prevText !== originalText ? originalText : formatText, '👉');
    setFormatText(formattedText);
  };

  const openPicker = () => {
    setShowEmojiPicker(prev => !prev)
  }

  const onEmojiSelect = (emoji) => {
    setSelectedEmoji(emoji.native)

    const formattedText = addEmoji(prevText.trim().length === 0 ? originalText : prevText !== originalText ? originalText : formatText, emoji.native);
    // const formattedText = addEmoji(originalText.trim().length === 0 ? formatText : prevText !== originalText ? formatText: originalText, emoji.native);
    setFormatText(formattedText);
    setShowEmojiPicker(false)
  };

  const addNumbers = () => {
    let splitText = prevText.length === 0 ? originalText.split('\n') : prevText !== originalText ? originalText.split('\n') : formatText.split('\n');

    splitText = splitText.map((item, key) => {
      // Check if there's an emoji added before the first character
      const emojiRegex = /\p{Emoji}/u;
      const match = item.match(emojiRegex);

      // Check if the line already starts with a number
      const startsWithNumber = /^\d+\./.test(item);

      if (!startsWithNumber && match) {
        // Replace the emoji with the number
        const emojiIndex = item.indexOf(match[0]);
        item = `${key + 1}. ${item.slice(0, emojiIndex)}${item.slice(emojiIndex + match[0].length)}`;
      } else if (!startsWithNumber) {
        // Add the number at the beginning
        item = `${key + 1}. ${item}`;
      }

      return item;
    });

    setFormatText(splitText.join('\n'));
  };

  return (
    <main className='format_main'>
      {/* <BoldTextEditor /> */}
      <section className='inputs'>
        {/* {userAuth.auth === null && <span className='uses'>Uses {usesLeft}/10</span>} */}
        {/* <span className='gear_icon'><FaGear /></span> */}
        <div>
          <span>ORIGINAL TEXT</span>
          <div><textarea value={originalText} onChange={e => setOriginalText(e.target.value)} /></div>
        </div>
        <div>
          <span>FORMATTED TEXT</span>
          <MdContentCopy className='copy_icon' onClick={() => {
            navigator.clipboard.writeText(formatText)
              .then(() => alert('Copied to clipboard!'))
          }} />
          <GrPowerReset className='reset_icon' onClick={
            () => {
              setPrevText('')

              setFormatText('')
              setOriginalText('')
            }
          } />
          <div>
            <textarea value={formatText} /></div>
        </div>
      </section>



      <section className="formatting">
        <div>
          <div className='option_title'>TEXT OPTIONS</div>
          <div className='text_options'>
            <button onClick={() => upperCaseAll()}>Uppercase </button>
            <button onClick={() => lowerCaseAll()}> Lowercase </button>
            <button onClick={() => capitalizeWords()}>Capitalize Words</button>
            <button onClick={() => capitalizeSentences()}>Capitalize Sentence</button>
          </div>
        </div>
        <div>
          <div className='option_title'>LIST OPTIONS</div>
          <div className='list_options'>

            <button onClick={openPicker}>Add emoji +</button>
            <button onClick={addCheckMarkEmoji}>✅ Check Mark</button>
            <button onClick={addRightEmoji}>👉 Right</button>
            <button onClick={addNumbers} className='list_item'>Numbers</button>
            <button onClick={capitalizeList} className='list_item'>Capitalize</button>
            <button onClick={sortAlphabeticalAscending} className='list_item'>Alpha Sort ↓</button>
            <button onClick={sortAlphabeticalDescending}>Alpha Sort ↑</button>
          </div>

        </div>

      </section>
      {showEmojiPicker && <div id="emoji_picker">
        <div className="close_picker" title="Close Picker" onClick={() => setShowEmojiPicker(false)}>x</div>
        <Picker
          data={data}
          onEmojiSelect={onEmojiSelect}
        />
      </div>}
    </main >
  )
}

export default Format